import React, { memo, useState } from 'react';
import { validators } from 'investira.sdk';
import { InlineInfo, CardInfo } from '../';
import ModalInfoDialog from './ModalInfoDialog';

/**
 * Renderiza o componente ModalInfo.
 *
 * @param {Object} props - Propriedades do componente.
 * @param {Object} props.modalContent - Componente renderizado dentro do modal.
 * @param {Object} props.modalProps - Props adicionais repassadas ao modal.
 * @param {string} props.label - Texto exibido como rótulo do componente.
 * @param {Object} props.infoProps - Props adicionais repassadas para `infoProps`.
 * @returns {JSX.Element|null} Elemento renderizado ou `null` quando não houver conteúdo para exibir.
 */
const ModalInfo = memo(props => {
  const { modalContent, modalProps, label, ...infoProps } = props;

  const [open, setOpen] = useState(false);

  if (validators.isEmpty(props.value)) {
    return null;
  }

  const infoModalProps = {
    iconName: 'others',
    onClick: () => {
      setOpen(true);
    }
  };

  const Content = modalContent;

  if (props.type === 'row') {
    return (
      <>
        <InlineInfo {...infoProps} label={label} modal={infoModalProps} />
        <ModalInfoDialog
          open={open}
          onClose={() => {
            setOpen(false);
          }}
          {...modalProps}
          title={label}>
          <Content />
        </ModalInfoDialog>
      </>
    );
  }

  if (props.type === 'card') {
    return (
      <>
        <CardInfo {...infoProps} label={label} modal={infoModalProps} />
        <ModalInfoDialog
          open={open}
          onClose={() => {
            setOpen(false);
          }}
          {...modalProps}
          title={label}>
          <Content />
        </ModalInfoDialog>
      </>
    );
  }

  return null;
});

ModalInfo.displayName = 'ModalInfo';

export default ModalInfo;
